var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"ds-btn",on:{"click":function($event){$event.preventDefault();return _vm.handleOvpFormGenerate($event)}}},[_vm._v("Ģenerēt OVP formas")])])}
var staticRenderFns = []

export { render, staticRenderFns }